import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isTwoColumn } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { CollectionContext } from '../../apps/collection/context';
import { RESIZE } from '../../config/constants';
import CollectionFilters from '../CollectionFilters';
import css from './Collection.module.scss';
import ErrorBoundary from '../ErrorBoundary';
import filterAndSort from '../../utils/collections/filterAndSort';
import HouseAd from '../HouseAd';
import ProductListItem from '../ProductListItem';
import ResultsListEmpty from '../ResultsListEmpty';
import updateArray from '../../utils/array/update'; // Store the expanded products here so we don't constantly create this.

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var expandedProducts = [];

var expandProducts = function expandProducts(products) {
  if (expandedProducts.length > 0) {
    return expandedProducts;
  }

  products.forEach(function (_ref, nodeIdx) {
    var node = _ref.node;

    if (!node.product) {
      return;
    }

    node.product.colorways.edges.forEach(function (_ref2, idx) {
      var colorway = _ref2.node;

      var newProduct = _objectSpread(_objectSpread({}, node.product), {}, {
        id: "".concat(node.product.id).concat(idx),
        colorways: {
          edges: [{
            node: colorway
          }]
        }
      });

      var newNode = _objectSpread(_objectSpread({}, node), {}, {
        id: "".concat(node.id).concat(nodeIdx).concat(idx),
        faceout: colorway,
        product: newProduct
      });

      expandedProducts.push({
        node: newNode
      });
    });
  });
  return expandedProducts;
};

var Collection = function Collection(_ref3) {
  var collection = _ref3.collection,
      initialFilters = _ref3.initialFilters;
  var rootEl = useRef(null);

  var _useState = useState(isTwoColumn()),
      _useState2 = _slicedToArray(_useState, 2),
      isMobile = _useState2[0],
      setIsMobile = _useState2[1];

  var _useState3 = useState([{
    ariaLabel: 'Sort By Newest First',
    label: 'Newest',
    value: 'default'
  }, {
    ariaLabel: 'Sort By Price Low To High',
    expand: true,
    label: 'Price ($-$$)',
    sort: function sort(_ref4, _ref5) {
      var product1 = _ref4.node.product;
      var product2 = _ref5.node.product;
      return product1.colorways.edges[0].node.variant.price - product2.colorways.edges[0].node.variant.price;
    },
    value: 'price-low-high'
  }, {
    ariaLabel: 'Sort By Top Rated First',
    label: 'Top Rated',
    sort: function sort(_ref6, _ref7) {
      var product1 = _ref6.node.product;
      var product2 = _ref7.node.product;
      return product2.properties.ratingAvg - product1.properties.ratingAvg;
    },
    value: 'top-rated'
  }]),
      _useState4 = _slicedToArray(_useState3, 1),
      sorts = _useState4[0];

  var _useState5 = useState(sorts[0]),
      _useState6 = _slicedToArray(_useState5, 2),
      sort = _useState6[0],
      setSort = _useState6[1];

  var _useState7 = useState(initialFilters),
      _useState8 = _slicedToArray(_useState7, 2),
      filters = _useState8[0],
      setFilters = _useState8[1];

  var _useState9 = useState(initialFilters.find(function (filter) {
    return filter.size === true;
  })),
      _useState10 = _slicedToArray(_useState9, 2),
      filterSize = _useState10[0],
      setFilterSize = _useState10[1];

  var _collection$propertie = collection.properties,
      gridDisplayEditorial = _collection$propertie.gridDisplayEditorial,
      gridDisplaySwatches = _collection$propertie.gridDisplaySwatches,
      toolbarDisplay = _collection$propertie.toolbarDisplay,
      toolbarDisplaySort = _collection$propertie.toolbarDisplaySort;
  var productSets = collection.productSets;

  var _useContext = useContext(CollectionContext),
      setGender = _useContext.setGender;

  useEffect(function () {
    var urlParams = new URLSearchParams(window.location.search);

    var replaceHistoryState = function replaceHistoryState() {
      try {
        var _window = window,
            location = _window.location,
            history = _window.history;
        filters.forEach(function (filter) {
          if (filter.selected) {
            urlParams.set(filter.param, filter.selected.value);
          } else {
            urlParams.delete(filter.param);
          }
        });
        history.replaceState({}, '', urlParams.toString() === '' ? location.pathname : "".concat(location.pathname, "?").concat(urlParams.toString()));
      } catch (_unused) {
        console.error('Could not replace state');
      }
    };

    replaceHistoryState();
    var genderFilter = filters.find(function (filter) {
      return filter.param === 'genderFilter';
    });
    if (genderFilter) setGender(genderFilter.selected.value);
  }, [filters, setGender]);
  useEffect(function () {
    var onResize = function onResize() {
      var newIsMobile = isTwoColumn();

      if (newIsMobile === isMobile) {
        return;
      }

      setIsMobile(newIsMobile);
    };

    window.addEventListener(RESIZE, onResize);
    return function () {
      window.removeEventListener(RESIZE, onResize);
    };
  }, [isMobile]);

  var scrollToTop = function scrollToTop() {
    window.scrollTo(0, rootEl.current.offsetTop - 70);
  };

  var onFilterClear = function onFilterClear() {
    var newFilters = filters.reduce(function (arr, filter) {
      return arr.concat(_objectSpread(_objectSpread({}, filter), {}, {
        selected: false
      }));
    }, []);
    setFilters(newFilters);
    scrollToTop();
  };

  var onFilterSelect = function onFilterSelect(filter, _ref8) {
    var value = _ref8.value;
    var newFilters = updateArray(filters, filters.indexOf(filter), {
      selected: filter.selected && filter.selected.value === value ? false : {
        label: value,
        value: value
      }
    });
    setFilters(newFilters);

    if (filter.size) {
      setFilterSize(newFilters.find(function (filt) {
        return filt.size === true;
      }));
    }

    scrollToTop();
  };

  var onSortSelect = function onSortSelect(_ref9) {
    var value = _ref9.value;
    var newSort = sorts.find(function (srt) {
      return srt.value === value;
    }) || sorts[0];
    setSort(newSort);
    scrollToTop();
  };

  var expanded = gridDisplaySwatches && filters.find(function (filt) {
    return filt.selected && filt.expand;
  });
  var sets = [];
  var itemsLength = 0;
  var filteringOrSorting = filters.find(function (filt) {
    return filt.selected;
  }) !== undefined || sort.value !== 'default';
  productSets.forEach(function (productSet) {
    var products = filterAndSort({
      products: expanded ? expandProducts(productSet.products.edges) : productSet.products.edges,
      filters: filters,
      sort: sort,
      filteringOrSorting: filteringOrSorting
    });

    var set = _objectSpread(_objectSpread({}, productSet), {}, {
      products: products
    });

    itemsLength += products.length;
    sets.push(set);
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      "aria-hidden": "true",
      className: cc([_defineProperty({}, css.emptyToolbar, !toolbarDisplay)]),
      ref: rootEl
    }), toolbarDisplay && /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(CollectionFilters, {
        clearFilters: onFilterClear,
        displaySort: toolbarDisplaySort,
        filtered: filters.find(function (filt) {
          return filt.selected;
        }) !== undefined,
        filters: filters,
        filterSelect: onFilterSelect,
        itemsLength: itemsLength,
        sort: sort,
        sorts: sorts,
        sortSelect: onSortSelect
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.content,
      children: [itemsLength > 0 && /*#__PURE__*/_jsx("div", {
        className: css.productSets,
        children: sets.map(function (productSet) {
          return /*#__PURE__*/_jsx("ul", {
            className: css.list,
            children: productSet.products.map(function (_ref11, idx) {
              var node = _ref11.node;
              return /*#__PURE__*/_jsxs(React.Fragment, {
                children: [node.component && /*#__PURE__*/_jsx(ErrorBoundary, {
                  children: /*#__PURE__*/_jsx(HouseAd, _objectSpread(_objectSpread({}, node.component), {}, {
                    isMobile: isMobile
                  }))
                }), node.product && /*#__PURE__*/_jsx("li", {
                  className: css.item,
                  children: /*#__PURE__*/_jsx(ErrorBoundary, {
                    children: /*#__PURE__*/_jsx(ProductListItem, _objectSpread(_objectSpread({}, node), {}, {
                      displaySwatches: gridDisplaySwatches && !expanded,
                      displayEditorial: gridDisplayEditorial,
                      displayWishListToggle: !node.product.properties.giftCard,
                      filter: filterSize,
                      isMobile: isMobile,
                      lazyload: isMobile && idx >= 2 || !isMobile && idx >= 3,
                      onPLP: true
                    }))
                  })
                })]
              }, node.id);
            })
          }, productSet.id);
        })
      }), itemsLength === 0 && /*#__PURE__*/_jsx(ResultsListEmpty, {
        onClear: onFilterClear
      })]
    })]
  });
};

Collection.defaultProps = {
  initialFilters: [],
  displayEditorial: false
};
Collection.propTypes = {
  collection: PropTypes.shape({
    properties: PropTypes.shape({
      banner: PropTypes.shape({}),
      filters: PropTypes.string,
      gridDisplayEditorial: PropTypes.bool,
      gridDisplaySwatches: PropTypes.bool,
      toolbarDisplay: PropTypes.bool,
      toolbarDisplaySort: PropTypes.bool
    }),
    productSets: PropTypes.arrayOf(PropTypes.shape())
  }).isRequired,
  initialFilters: PropTypes.arrayOf(PropTypes.shape()),
  displayEditorial: PropTypes.bool
};
export default Collection;